<template>
  <div class="container login-register-wrapper-box-container">
    <div class="row my-5 justify-content-center">
      <div class="col-lg-7 col-12">
        <div class="container">
          <LoginRegisterResetWrapperBox />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  // Vue
  import { onBeforeUnmount, onMounted, onUnmounted } from 'vue'

  // Config
  import UserInfoFormEnum from '@/config/UserInfoFormEnum'

  // Components
  import LoginRegisterResetWrapperBox from '@/components/LoginRegister/LoginRegisterResetWrapperBox.vue'

  // common components
  import Overlay from '@/components/common/Overlay/v1/Overlay.vue'
  import StickyBar from '@/components/UI/StickyBar.vue'

  // logic
  // import refresh from "@/logic/contact/refresh"

  // Utils
  import { getQueryParams } from '@/utils'

  // Composables
  import useLoading from '@/composables/useLoading'

  // Store
  import { useStore } from 'vuex'

  // Cookies
  import Cookies from 'js-cookie'
  import { State } from '@/store/types'
  import { UserInfo } from '@/services/AuthService.interface'

  import current_form from '@/state/current_form'

  // Login state
  import locale from '@/state/locale'

  // Logic
  import navigateAfterAuth from '@/logic/contact/navigateAfterAuth'

  import { CookieName } from '@/config/cookies'

  const store = useStore<State>()

  const checkHasRefreshToken = (): boolean => {
    const refreshToken = Cookies.get(CookieName.REFRESH_TOKEN)
    return !!refreshToken
  }

  onMounted(async () => {
    locale.value = store.getters.getLocale

    const queryParams = getQueryParams()

    const hasRefreshToken: boolean = checkHasRefreshToken()

    // If we have the hash, that means we should show the new password form
    if (queryParams.hash) {
      current_form.value = UserInfoFormEnum.NewPassword
      return
    }

    if (!store.state.auth?.user) {
      current_form.value = UserInfoFormEnum.Check
    }

    if (!hasRefreshToken) return

    const { startLoadingThis, stopLoadingThis } = useLoading()
    try {
      startLoadingThis()

      const userInfo: UserInfo = await store.dispatch('auth/refresh')

      if (queryParams.redirect_to) {
        window.location.href = queryParams.redirect_to
        return
      }

      if (userInfo) {
        await navigateAfterAuth(userInfo.email)
      }
    } catch (err) {
      stopLoadingThis()
    }
  })

  onBeforeUnmount(() => {
    current_form.value = UserInfoFormEnum.Check
  })
</script>

<style></style>
